import React from "react";
import { useGoogleAnalytics } from "../../hooks/useGoogleAnalytics";
import { useIsPreviewMode } from "../../hooks/useIsPreviewMode";
import { IconButton } from "../icon-button";

export function PreviewButton() {
	const [, setIsPreviewMode] = useIsPreviewMode();
	const googleAnalytics = useGoogleAnalytics();

	return (
		<IconButton
			iconName="preview"
			onClick={() => {
				googleAnalytics.trackEventToGa({
					trackingAction: "PreviewClicked",
				});
				setIsPreviewMode(true);
			}}
			elevated
		/>
	);
}
